// extracted by mini-css-extract-plugin
module.exports = {"bgPatternContainer":"styles_bgPatternContainer__y64u8","bgPattern":"styles_bgPattern__Ua6Bs","gradient":"styles_gradient__pgZdl"};